import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'sam4-close-button',
    templateUrl: './close-button.component.html',
    styleUrls: ['./close-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CloseButtonComponent implements OnInit {
    //@HostBinding('role') role = 'presentation';
    @Input('click') clickFunction!: Function;

    constructor() {
    }

    ngOnInit(): void {
    }

}
